module.exports = __webpack_public_path__ + "static/DetectiveGui0-82ae80704bd961ab3e3c342635096138.webp";